module.exports = __webpack_public_path__ + "img/16.2d2dfe78.jpg";